<template>
  <div class="rdsSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Select
          v-model="accountType"
          filterable
          :placeholder="$t('alarms.common.filterByAccountType')"
          :transfer="true"
        >
          <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in accountTypeList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
        />
      </Col>
      <!-- todo 地区暂时不需要
            <Col span="4" style="padding-right:10px">
                <Select v-model="region" filterable placeholder="按区域筛选"  @on-change="searchRegion(region)" :transfer="true">
                    <Option value="" selected>{{ $t('alarms.common.allRegion') }}</Option>
                    <Option :value="item.name" v-for="item in regionList" :key="item.name">{{item.name}}</Option>
                </Select>
            </Col>
            -->
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="databaseId"
          :placeholder="$t('alarms.database.filterByDBInstance')"
        />
      </Col>
      <Col span="6">
        <Button
          type="primary"
          v-hasPermission="['monitor:relationalDatabaseServiceMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
        <Button
          type="warning"
          :loading="modal_loading"
          @click="exportStatisticsList"
          v-hasPermission="[
            'monitor:relationalDatabaseServiceMonitor:export_statistics'
          ]"
          >{{ $t("common.exportStatistics") }}</Button
        >
        <Button
          type="warning"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="['monitor:relationalDatabaseServiceMonitor:export']"
          >{{ $t("common.export") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
export default {
  name: "RelationalDatabaseServiceMonitorSearch",
  // 接受父组件的值
  props: {
    rdsColumns: Array
  },
  data() {
    return {
      tag: "",
      modal_loading: false,
      region: "",
      databaseId: "",
      regionList: [],
      accountName: "",
      accountType: "",
      companyId: "",
      company: getCookie(global.companyId),
      companyList: [],
      accountTypeList: [
        {
          id: 0,
          name: "AWS"
        },
        {
          id: 1,
          name: "Aliyun"
        },
        {
          id: 2,
          name: "Azure"
        },
        {
          id: 4,
          name: "GCP"
        }
      ]
    };
  },
  mounted: function() {
    this.getQueryRegions();
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountType", this.accountType);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("databaseId", this.databaseId);
      this.$parent.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    //查询地区
    getQueryRegions: function() {
      this.$api.account
        .queryRegions("userName", getCookie(global.cookieName))
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 按区域筛选
    searchRegion: function() {
      eventBus.$emit("region", this.region);
      this.$parent.showAll();
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });

      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureDatabaseStatistics({
          companyId: this.companyId,
          accountType: this.accountType,
          accountName: this.accountName,
          databaseId: this.databaseId,
          tag: this.tag,
          // "region":  this.region,
          pageNum: 1,
          pageSize: 10000,
          monitorModule: 1
        })
        .then(res => {
          let fileName = "数据库使用情况.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    },
    //导出统计
    exportStatisticsList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });

      // 下载Excel 文件
      this.$api.resourceManagement
        .exportDatabaseStatistics({
          companyId: this.companyId,
          accountType: this.accountType,
          accountName: this.accountName,
          databaseId: this.databaseId,
          tag: this.tag,
          monitorModule: 1,
          // 动态表头
          title: this.rdsColumns
        })
        .then(res => {
          let fileName = "数据库使用统计情况.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>
<style scoped>
.rdsSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/RelationalDatabaseServiceMonitorSearch.vue